import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SxProps, Theme } from '@mui/material/styles';

type Props = {
  sx?: SxProps<Theme>;
};

const containerSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '60vh',
  px: 2,
} as const;

const Loading = ({ sx }: Props) => (
  <Box sx={{ ...containerSx, ...(sx ?? {}) }}>
    <Typography
      sx={{
        color: '#64748b',
        letterSpacing: '0.2em',
        textTransform: 'uppercase',
        fontSize: '0.875rem',
        fontWeight: 500,
        animation: 'pulseLoading 1.4s ease-in-out infinite',
        '@keyframes pulseLoading': {
          '0%, 100%': { opacity: 0.25 },
          '50%': { opacity: 1 },
        },
      }}
    >
      Loading
    </Typography>
  </Box>
);

export default Loading;
